import React, { ReactElement, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Select } from 'antd';

import { getCategoryLabel } from 'leash/components/packagesHeader/PackagesHeader';
import { usePackagesContext } from 'leash/context/packages/PackagesContext';
import { PackagesRouteParams } from 'leash/pages/packages/Packages';
import { LeashRoutes, PackageSearchCategory } from 'leash/utilities/const';
import { PackageSearchCategories } from 'leash/types';
import {
  PackageSearchInput,
  PackageSearchSelect,
  PackageSearchStyled,
} from './PackageSearch.styles';

const { Option } = Select;

export const isAcceptOnlyNumber = (searchCategory: PackageSearchCategories): boolean => {
  switch (searchCategory) {
    case PackageSearchCategory.BreederId:
    case PackageSearchCategory.PuppyId:
    case PackageSearchCategory.ContactId:
      return true;
    default:
      return false;
  }
};

export function PackageSearch(): ReactElement {
  const history = useHistory();
  const { category, query }: PackagesRouteParams = useParams();
  const [searchCategory, setSearchCategory] = useState<PackageSearchCategories>(
    category ?? PackageSearchCategory.PuppyId,
  );
  const [searchQuery, setSearchQuery] = useState<string | undefined>(query ?? undefined);
  const { dispatch } = usePackagesContext();

  useEffect(() => {
    setSearchCategory(category ?? PackageSearchCategory.PuppyId);
    setSearchQuery(query);
  }, [category, query]);

  const handleOnChangeSearchCategory = (category: PackageSearchCategories) => {
    setSearchCategory(category);
  };

  const handleOnChangeSearchQuery = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchQuery(value);
  };

  const handleOnSearch = (query: string) => {
    if (!query || !searchCategory) return;
    history.push(`${LeashRoutes.Packages}/${searchCategory}/${query.trim()}`);
    dispatch({ type: 'SET_FETCH_PACKAGES' });
  };

  return (
    <PackageSearchStyled data-testid="package-search">
      <PackageSearchSelect
        value={searchCategory}
        onChange={handleOnChangeSearchCategory}
        data-testid="package-search-dropdown"
      >
        {Object.entries(PackageSearchCategory).map((entry) => {
          const [key, value] = entry;
          return (
            <Option value={value} key={key}>
              {getCategoryLabel(value)}
            </Option>
          );
        })}
      </PackageSearchSelect>
      <PackageSearchInput
        data-testid="search-input"
        placeholder="Input search text"
        onSearch={handleOnSearch}
        allowClear
        type={isAcceptOnlyNumber(searchCategory) ? 'number' : 'text'}
        onChange={handleOnChangeSearchQuery}
        value={searchQuery}
      />
    </PackageSearchStyled>
  );
}
